import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import type { RecentSearch, GlobalSearchResultsData } from '../types';
import GlobalSearchProducts from './GlobalSearchProducts';
import GlobalSearchRecentSearches from './GlobalSearchRecentSearches';
import GlobalSearchSuggestedQuery from './GlobalSearchSuggestedQuery';
import GlobalSearchSuggestions from './GlobalSearchSuggestions';
import '../styles/GlobalSearchResults.scss';

interface GlobalSearchResultsProps {
    headerButtonLabel: string;
    headerTitle: string;
    isDesktopView: boolean;
    isMediaDiscountVoucher: boolean;
    isRecentSearchesVisible: boolean;
    recentSearches: RecentSearch[];
    searchResults: GlobalSearchResultsData;
    searchTerm: string;
    suggestedQuery: string;
    suggestedQueryLabel: string;
    onDeleteAllClick: () => void;
    onProductClick: (eanId: number, index: number, productId: number, variantId: number) => void;
    onRecentSearchClick: (id: string) => void;
    onSuggestionClick: (navigationId: number) => void;
    onTouchScreen: (state: boolean) => void;
}

function GlobalSearchResults({
    headerButtonLabel,
    headerTitle,
    isDesktopView,
    isMediaDiscountVoucher,
    isRecentSearchesVisible,
    recentSearches,
    searchResults,
    searchTerm,
    suggestedQuery,
    suggestedQueryLabel,
    onDeleteAllClick,
    onProductClick,
    onRecentSearchClick,
    onSuggestionClick,
    onTouchScreen,
}: GlobalSearchResultsProps) {
    const [block, BEMElement] = BEMBlock('global-search-results');

    return (
        <div
            className={classNames(block)}
            onTouchStart={() => onTouchScreen(true)}
        >
            {isRecentSearchesVisible ? (
                <GlobalSearchRecentSearches
                    headerButtonLabel={headerButtonLabel}
                    headerTitle={headerTitle}
                    recentSearches={recentSearches}
                    onDeleteAllClick={onDeleteAllClick}
                    onRecentSearchClick={onRecentSearchClick}
                />
            ) : (
                <>
                    {suggestedQuery && (
                        <GlobalSearchSuggestedQuery
                            label={suggestedQueryLabel}
                            searchTerm={searchTerm}
                            suggestedQuery={suggestedQuery}
                        />
                    )}
                    <GlobalSearchSuggestions
                        searchResults={searchResults}
                        searchTerm={searchTerm}
                        onSearchSuggestionClick={onSuggestionClick}
                    />
                    <GlobalSearchProducts
                        isMediaDiscountVoucher={isMediaDiscountVoucher}
                        searchResults={searchResults}
                        searchTerm={searchTerm}
                        onSearchProductClick={onProductClick}
                    />
                    {isDesktopView && (
                        <div className={BEMElement('overlay')} />
                    )}
                </>
            )}
        </div>
    );
}

export default GlobalSearchResults;
